import { getSVG } from './components/icons-loader.js';
import { showMoreFaqs, accordion } from './components/accordion.js';

document.addEventListener("DOMContentLoaded", function () {
  getSVG();
  accordion('.faqs-cards');
  showMoreFaqs();
});
